export class EnableSourceAccountMetricsConfigRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "aws",
            "baseName": "aws",
            "type": "AwsAccountMetricsDestination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EnableSourceAccountMetricsConfigRequest.attributeTypeMap;
    }
    constructor() {
    }
}
